export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/74cc88c7571ddfe8037db442e45677ad.svg";